import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ErrorAlert } from './error-alert';

@Injectable()
export class ErrorAlertService {

    private requirePopupSource = new Subject<ErrorAlert>();
    private acceptPopupSource = new Subject<ErrorAlert>();
    private deletePopupSource = new Subject<ErrorAlert>();
    private updatePopupSource = new Subject<ErrorAlert>();
    // Observable string sources
    private tasks = new Subject<any>();
    // Observable string streams
    tasksConfirmed$ = this.tasks.asObservable();

    requirePopup$ = this.requirePopupSource.asObservable();
    accept = this.acceptPopupSource.asObservable();
    delete = this.deletePopupSource.asObservable();
    update = this.updatePopupSource.asObservable();

    confirm(popup: ErrorAlert) {
        this.requirePopupSource.next(popup);
        return this;
    }

    onAccept() {
        this.acceptPopupSource.next();
    }

    onDelete() {
        this.deletePopupSource.next();
    }

    onUpdate() {
        this.updatePopupSource.next();
    }

    postTask(task: any) {

        this.tasks.next(task);
    }

}
